import { useApi } from "hooks"
import { useQuery } from '@tanstack/react-query'


const useGetCarousels = (groupId) => {

  const { apiFetch } = useApi()

  const url = `/carrusels?groupId=${groupId}`

  const getCarousels = async () => {
    if (!groupId) return

    return apiFetch({ url })
      .then( res => res.data)
  }
  
  const options = {
    staleTime: 60000 * 30, // 30 min
    placeholderData: []
  }

  return useQuery(['carousels', groupId, 'lang'], getCarousels, options)
}

export default useGetCarousels;